import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import StructuredData from '../components/StructuredData';
import '../styles/MessagePage.scss';

const PrincipalMessage = () => {
  const { t } = useTranslation();

  return (
    <div className="message-page">
      <StructuredData type="organization" />
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`${t('principal_message_title')} - ${t('school_name')}`}</title>
        <meta
          name="description"
          content={`Read the inspiring message from our Principal, ${t('principal_name')}, highlighting Prabhat Tara Vidya Niketan's focus on holistic education and student development.`}
        />
        <link
          rel="canonical"
          href="https://prabhattaravidyaniketan.in/principal-message"
        />
        <link rel="icon" href="/images/logo.jpg" />
      </Helmet>

      <div className="container">
        <h2 className="message-title">{t('principal_message_title')}</h2>
        <div className="profile-section">
          <img
            src="/images/principal.png"
            alt={`Principal ${t('principal_name')}`}
            className="profile-image"
            loading="lazy"
          />
          <h3>{t('principal_name')}</h3>
          <p className="designation">{t('principal_designation')}</p>
        </div>
        <p className="message-text">
          {t('principal_message')}
        </p>
      </div>
    </div>
  );
};

export default PrincipalMessage;
